/* eslint-disable no-script-url */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import sessionActions from '../../actions/SessionActions';
import { t } from '../../services/i18nService';
import uiActions from '../../actions/UIActions';
import uiConstants from '../../constants/UIConstants';
import storeManager from '../../store/StoreManager';
import styles from './options.scss';

import OptionsTopBar from './OptionsTopBar';
import OptionsChoiceList from './OptionsChoiceList';

class OptionsZoomFactorChooser extends React.Component {
    static propTypes = {
        ui: PropTypes.object,
    };

    /**
     * @param {string} factor: zoom-small, zoom-medium or zoom-large
     * */
    handleZoomFactorChange = (factor) => {
        storeManager.dispatch(uiActions.uiSetZoomFactor(factor));
    };

    render() {
        const { ui } = this.props;
        const current = ui.zoomFactor ? ui.zoomFactor : uiConstants.ZOOM_FACTOR.SMALL;
        const choices = Object.values(uiConstants.ZOOM_FACTOR).map(factor => ({
            identifier: factor,
            title: t(`options.${factor}`),
            isSelected: current === factor,
        }));

        return (
            <div>
                <OptionsTopBar title={t('options.zoom-title')} showOptionsButton />
                <div className={styles.mainContentArea} role="main">
                    <OptionsChoiceList
                        selectionHandler={this.handleZoomFactorChange}
                        choices={choices}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ui: state.ui,
    };
}

const OptionsZoomFactor = connect(mapStateToProps, sessionActions)(OptionsZoomFactorChooser);
export default OptionsZoomFactor;
